import React from 'react';
import PropTypes from "prop-types";

import Framework from "@beardeddevops/react.framework";

export default class SelectBoundBook extends React.Component {
	static propTypes = {
		object: PropTypes.object.isRequired,
		properties: PropTypes.object.isRequired,
		shouldLoad: PropTypes.bool.isRequired,
		onSelectUpdate: PropTypes.func.isRequired,
	};

	render() {

		/** @type {Transactions_Collections_Object} object */
		let object = this.props.object;
		let {properties, shouldLoad, onSelectUpdate} = this.props;

		return <div className={'form-group'}>
			<div className="row">
				<div className="col-4">
					<span className="input-label">Bound Book</span>
				</div>
				<div className="col-8">
					<Framework.Elements.Select
						objectKey={object.location_binary_id + '-' + object.location}
						parent={object.location_binary_id + '-' + object.location}
						shouldLoad={shouldLoad}
						update={onSelectUpdate}
						property={properties.bound_book}
						value={object.bound_book}
						binary_id={object.bound_book_binary_id}
						error={object.bound_book_error}
						object={object.location_bound_books}
						nullable={true}
						default={{
							value: "",
							label: object.locations_related_by_location ? object.locations_related_by_location.bound_book : 'Primary'
						}}
						// filter={
						// 	/** @param {Locations_Bound_Books_Properties} option */
						// 		(option) => {
						// 		if (object.location) {
						// 			return option.location === object.location && option.location_binary_id === object.location_binary_id;
						// 		} else {
						// 			return false
						// 		}
						// 	}
						// }
					/>
				</div>
			</div>
		</div>
	}
}

